export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[900px] mx-auto">
          <div className="bg-primary-500 rounded-lg overflow-hidden flex flex-col md:flex-row items-center">
            <div className="p-8 md:p-12 flex-1 text-center md:text-left">
              <h2 className="text-2xl md:text-3xl font-display text-background-50 mb-3">
                随时随地，轻松吃瓜
              </h2>
              <p className="text-sm md:text-base text-background-50/80 leading-relaxed mb-6">
                吃瓜爆料移动端即将上线！支持 iOS 和 Android 双平台，
                让你随时随地获取最新吃瓜爆料资讯，不再错过任何热点。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center md:justify-start gap-3">
                <span className="inline-flex items-center gap-2 px-5 py-2.5 bg-background-50 text-primary-600 font-medium rounded-md whitespace-nowrap cursor-pointer text-sm hover:bg-background-100 transition-colors duration-200">
                  <i className="ri-apple-line w-4 h-4 flex items-center justify-center"></i>
                  iOS 版即将推出
                </span>
                <span className="inline-flex items-center gap-2 px-5 py-2.5 bg-background-50/20 text-background-50 border border-background-50/30 font-medium rounded-md whitespace-nowrap cursor-pointer text-sm hover:bg-background-50/30 transition-colors duration-200">
                  <i className="ri-android-line w-4 h-4 flex items-center justify-center"></i>
                  Android 版即将推出
                </span>
              </div>
            </div>
            <div className="w-full md:w-[280px] p-6 md:p-0 flex justify-center">
              <div className="w-[180px] h-[360px] bg-background-50/10 rounded-2xl border-2 border-background-50/20 flex items-center justify-center relative overflow-hidden">
                <div className="text-center">
                  <i className="ri-smartphone-line text-5xl text-background-50/60 w-12 h-12 flex items-center justify-center mx-auto"></i>
                  <p className="text-background-50/60 text-xs mt-2">移动端预览</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}